<template>
  <div class="container">
    <el-container>
      <el-header class="header">
        <headers />
      </el-header>
      <el-container>
        <slider />
        <el-main>
          <div class="main_box">
            <div class="main_main">
              <!-- Page Header -->
              <div class="page_header">Manage Hold CAPA Requests</div>
              <!-- Page Header -->
              <div class="page_main">
                <div class="file-panel">
                  <div class="panel-header">
                    <div class="table-title">CAPA Request Hold</div>
                    <el-input
                      v-model="keyword"
                      placeholder="Search"
                      clearable
                      class="search-input"
                    >
                      <i
                        slot="prefix"
                        class="el-input__icon el-icon-search"
                      ></i>
                    </el-input>
                  </div>
                  <el-table
                    :data="holdRequestTableData"
                    border
                    stripe
                    header-cell-class-name="table-header-cell"
                    class="file-table"
                    empty-text="No hold CAPA requests"
                  >
                    <el-table-column label="Actions" width="320" align="center">
                      <template slot-scope="scope">
                        <el-button
                          type="primary"
                          size="mini"
                          @click="
                            handleOperation('Start Investigation', scope.row)
                          "
                        >
                          Start Investigation
                        </el-button>
                        <el-button
                          type="primary"
                          size="mini"
                          @click="handleOperation('Edit Request', scope.row)"
                        >
                          Edit Request
                        </el-button>
                      </template>
                    </el-table-column>

                    <el-table-column
                      prop="request_id"
                      label="CAPA ID"
                      min-width="180"
                      sortable
                    />

                    <el-table-column
                      prop="description"
                      label="Description"
                      min-width="200"
                      sortable
                    />

                    <el-table-column
                      prop="company_name"
                      label="Company"
                      min-width="140"
                      sortable
                    />

                    <el-table-column
                      prop="departments_name"
                      label="Department"
                      min-width="140"
                      sortable
                    />

                    <el-table-column
                      prop="priority"
                      label="Priority"
                      min-width="120"
                    >
                      <template slot-scope="scope">
                        <div v-if="scope.row.priority == 1">High</div>
                        <div v-if="scope.row.priority == 2">Medium</div>
                        <div v-if="scope.row.priority == 3">Low</div>
                        <div v-if="!scope.row.priority">/</div>
                      </template>
                    </el-table-column>

                    <el-table-column label="Details" width="120" align="center">
                      <template slot-scope="scope">
                        <el-button
                          type="primary"
                          size="mini"
                          @click="handleOperation('Details', scope.row)"
                        >
                          Details
                        </el-button>
                      </template>
                    </el-table-column>
                  </el-table>

                  <div class="pagination">
                    <el-pagination
                      @size-change="handleSizeChange"
                      @current-change="handlePageChange"
                      :current-page="page"
                      :page-sizes="[5, 10, 20, 50]"
                      :page-size="page_size"
                      layout="total, sizes, prev, pager, next"
                      :total="pageTotal"
                    >
                    </el-pagination>
                  </div>
                </div>

                <!-- Footer Buttons -->
                <div class="footer-actions">
                  <el-button type="primary" size="small" @click="handleClose">
                    Close
                  </el-button>
                </div>
              </div>
            </div>
          </div>
        </el-main>
      </el-container>
    </el-container>

    <!-- Start Investigation Dialog -->
    <el-dialog
      title="Start Investigation"
      :visible.sync="dialogVisible"
      width="30%"
    >
      <div class="save_box">
        <div class="form_box">
          <div style="padding-bottom: 20px; font-weight: bold; font-size: 16px">
            Please complete the following information
          </div>

          <el-form
            :model="ruleForm"
            :rules="rules"
            ref="ruleForm"
            label-width="0px"
          >
            <div class="input_el">
              <div class="tit required">Priority</div>
              <el-form-item label="" prop="priority">
                <el-select
                  filterable
                  v-model="ruleForm.priority"
                  placeholder="Please select"
                  class="full-width"
                  clearable
                >
                  <el-option label="High" value="1"></el-option>
                  <el-option label="Medium" value="2"></el-option>
                  <el-option label="Low" value="3"></el-option>
                </el-select>
              </el-form-item>
            </div>

            <div class="input_el">
              <div class="tit required">Investigator</div>
              <el-form-item label="" prop="account">
                <el-select
                  filterable
                  v-model="ruleForm.account"
                  placeholder="Please select"
                  class="full-width"
                  clearable
                >
                  <el-option
                    v-for="value in usersList"
                    :key="value.id"
                    :label="value.username"
                    :value="value.id"
                  ></el-option>
                </el-select>
              </el-form-item>
            </div>

            <div class="input_el">
              <div class="tit required">Response Due Date</div>
              <el-form-item label="" prop="response_end_time">
                <el-date-picker
                  v-model="ruleForm.response_end_time"
                  type="date"
                  placeholder="Please select"
                  style="width: 100%"
                >
                </el-date-picker>
              </el-form-item>
            </div>

            <div class="input_el">
              <div class="tit">Comments</div>
              <el-form-item label="" prop="remark">
                <el-input
                  type="textarea"
                  :rows="3"
                  v-model="ruleForm.remark"
                  placeholder="Please enter"
                  clearable
                ></el-input>
              </el-form-item>
            </div>

            <div class="input_el">
              <div class="tit required">Password</div>
              <el-form-item label="" prop="signature">
                <el-input
                  v-model="ruleForm.signature"
                  placeholder="Please enter"
                  clearable
                  show-password
                ></el-input>
              </el-form-item>
            </div>
          </el-form>
        </div>

        <div class="btn_box">
          <van-button
            class="btn_el"
            type="default"
            round
            @click="dialogVisible = false"
          >
            Cancel
          </van-button>

          <van-button
            class="btn_el"
            round
            color="linear-gradient(to right, #7BC1FF, #4886FF)"
            @click="submitForm('ruleForm')"
          >
            Sign
          </van-button>
        </div>
      </div>
    </el-dialog>
    <!-- Start Investigation Dialog -->

    <!-- Loading -->
    <transition name="fade">
      <div class="loading" v-show="isLoading">
        <van-loading />
      </div>
    </transition>
    <!-- Loading -->
  </div>
</template>

<script>
import headers from "@/component/header.vue";
import slider from "@/component/slider.vue";
import { usersList } from "@/api/system/user";
import {
  capaHoldRequest,
  capaStartInvestigation,
} from "@/api/capaManage/configCapa/capaHoldRequest/index";
import moment from "moment";
import md5 from "js-md5";

moment.locale("en");

export default {
  components: {
    headers,
    slider,
  },
  data() {
    return {
      isLoading: true,
      dialogVisible: false,
      keyword: "",
      capa_id: "",
      tableData: [],
      ruleForm: {
        priority: "",
        account: "",
        response_end_time: "",
        remark: "",
        signature: "",
      },
      rules: {
        priority: [
          { required: true, message: "Please select", trigger: "change" },
        ],
        account: [
          { required: true, message: "Please select", trigger: "change" },
        ],
        response_end_time: [
          { required: true, message: "Please select", trigger: "change" },
        ],
        signature: [
          { required: true, message: "Please enter", trigger: "blur" },
        ],
      },
      usersList: [],
      page: 1,
      page_size: 10,
      pageTotal: 0,
    };
  },

  created() {
    let that = this;
  },

  mounted() {
    let that = this;
    that.isLoading = false;
    that.getTableData();

    // Request user list
    usersList({
      page: 1,
      page_size: 9999,
      status: 1,
    }).then((res) => {
      that.usersList = res.data.data;
    });
  },

  computed: {
    holdRequestTableData() {
      return this.filterTableData(this.tableData, this.keyword);
    },
  },

  methods: {
    filterTableData(source, keyword) {
      if (!keyword || !keyword.trim()) return source;

      const lowerKeyword = keyword.toLowerCase().trim();

      return source.filter((item) => {
        const text = this.flattenValues(item).toLowerCase();
        return text.includes(lowerKeyword);
      });
    },

    flattenValues(data) {
      if (data === null || data === undefined) return "";

      if (Array.isArray(data)) {
        return data.map((item) => this.flattenValues(item)).join(" ");
      }

      if (typeof data === "object") {
        return Object.values(data)
          .map((val) => this.flattenValues(val))
          .join(" ");
      }

      return String(data);
    },

    getTableData() {
      let that = this;

      capaHoldRequest({
        page: 1,
        page_size: 10,
      }).then((res) => {
        if (res.code == 200) {
          that.tableData = res.data.data;
          that.pageTotal = res.data.total;
        }
      });
    },

    // Change page size
    handleSizeChange(value) {
      let that = this;
      that.page_size = value;
      that.getTableData();
    },

    // Change page
    handlePageChange(value) {
      let that = this;
      that.page = value;
      that.getTableData();
    },

    handleOperation(title, value) {
      let that = this;

      switch (title) {
        case "Start Investigation":
          that.dialogVisible = true;
          that.capa_id = value.id;
          break;

        case "Edit Request":
          that.$router.push({
            path: "/CapaControl/capaHoldEdit",
            query: {
              oid: value.id,
              step: value.step,
            },
          });
          break;

        case "Details":
          const routeData = that.$router.resolve({
            path: "/CapaControl/searchDeatil",
            query: {
              oid: value.id,
            },
          });

          window.open(routeData.href, "_blank");
          break;
      }
    },

    submitForm(formName) {
      let that = this;

      that.$refs[formName].validate((valid) => {
        if (!valid) return;

        that.$toast.loading({
          duration: 0,
          forbidClick: true,
        });

        capaStartInvestigation({
          id: that.capa_id,
          status: 2,
          priority: that.ruleForm.priority,
          investigator: that.ruleForm.account,
          end_time: moment(that.ruleForm.response_end_time).valueOf() / 1000,
          remark: that.ruleForm.remark,
          signature: md5(that.ruleForm.signature + "AiisoQms2026"),
        }).then((res) => {
          if (res.code == 200) {
            that.$toast.clear();

            that.$message.success("Operation successful");

            setTimeout(() => {
              that.$router.push({
                path: "/task-list",
              });
            }, 800);
          }
        });
      });
    },

    handleClose() {
      let that = this;
      that.$router.back();
    },

    goUrl(url) {
      let that = this;
      that.$router.push(url);
    },
  },
};
</script>

<style lang="less" scoped>
.save_box {
  .btn_box {
    text-align: right;
    .btn_el {
      margin-left: 10px;
      padding: 12px 24px;
      .van-button__text {
        font-size: 16px;
      }
    }
  }
  .form_box {
    .input_el {
      .tit {
        padding-bottom: 5px;
        font-size: 14px;
        color: #333333;
      }
      .required::before {
        content: "*";
        color: red;
        margin-right: 2px;
      }

      .full-width {
        width: 100%;
      }
    }
  }
}
//主要内容
.main_main {
  .page_main {
    padding: 18px 20px;
    .btn_el {
      margin: 10px 0 20px 0;
      .tips {
        padding: 6px 8px;
        background-color: #ffb1001a;
        border-radius: 6px;
        font-size: 16px;
        font-weight: bold;
      }
    }
  }
  //页头
  .page_header {
    padding: 0 20px;
    height: 60px;
    line-height: 60px;
    background-color: #d8e4f0;
    font-size: 24px;
    font-weight: bold;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.075);
  }
}
</style>
<style scoped>
.main_box {
  height: calc(100vh - 60px);
  overflow-y: auto;
}
.main_box .main_main {
  position: relative;
  min-height: calc(100% - 0px);
  max-height: auto;
  background-color: #fafafa;
}
.el-header,
.el-main {
  padding: 0;
}

.file-panel {
  background: #fff;
  border: 1px solid #dcdfe6;
  margin-top: 40px;
}

.panel-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 16px;
}

.table-title {
  font-size: 18px;
  font-weight: 700;
  color: #2f343b;
}

.search-input {
  width: 220px;
}

.file-table {
  width: 100%;
  margin-top: 8px;
}

.pagination {
  margin: 10px 0;
  text-align: right;
}

.footer-actions {
  display: flex;
  margin-top: 50px;
  justify-content: center;
  align-self: center;
}
</style>

